import React, { useEffect, useState } from 'react'
import {
    DTO_NTSPCaseNote,
    NTSP_StatPortalProps,
    useGetCommentsMutation,
    useSaveCommentsMutation,
} from './Ntsp_Slice'
import { PatientDetailsHeader } from './PatientHeader'
import { convertEasternToLocal } from './NTSP_StatPortal'
import { FoundationsButton } from '../../GenericComponents/button'
import { useSelector } from 'react-redux'

import { validateForm } from './NTSP_StatPortal'
import { usePromiseDebounce } from '../../Hooks/usePromiseDebounce' //FP-12575 Debounce save for UI actions
declare let window: any
const UnicornApp = window.unicornInstance as any

const Comments: React.FC<NTSP_StatPortalProps> = ({
    form,
    handleTabSwitch,
    handleClear,
    handleSave,
    NTSPElements,
    isSaved,
    validationSchema,
    errors,
    setErrors,
}) => {
    if (errors === undefined) errors = {}
    if (setErrors === undefined) setErrors = (errors: any) => {}
    if (validationSchema === undefined) validationSchema = {}
    const [comment, setComment] = useState('')
    const timezone = useSelector((state: any) => state.ntspSlice.timezone)
    const [history, setHistory] = useState<DTO_NTSPCaseNote[]>([])
    const [currentUserId, setcurrentUserId] = useState<number>(0)
    const [currentUserName, setcurrentUserName] = useState<string>('')
    const [GetComments] = useGetCommentsMutation()
    const [SaveComments] = useSaveCommentsMutation()
    const [remainigNotes, setRemainingNotes] = useState(2048)
    const [error, setError] = useState<boolean>(false)
    const [submitted, setSubmitted] = useState<boolean>(false)
    const [formError, setFormError] = useState<string>('')

    const wrapHandleClear = async () => {
        setSubmitted(true)
        const tempErrors = validateForm(form, validationSchema)
        const allErrors = { ...errors, ...tempErrors }
        setErrors(allErrors)
        if (Object.values(allErrors).some(Boolean)) {
            setFormError('Please fix the errors before saving.')
            return
        }
        setFormError('')
        if (handleSave) await handleSave(true)
        if (handleClear) handleClear()
    }
    useEffect(() => {
        UnicornApp.getCurrentUserFromAPI()
            .then((me: any) => {
                if (me) {
                    setcurrentUserId(me.attributes.id)
                    setcurrentUserName(`${me.attributes.firstname} ${me.attributes.lastName}`)
                }
            })
            .catch((error: any) => {
                console.error('Error fetching current user:', error)
                setcurrentUserId(0) // Fallback if user fetch fails
            })
        if (form?.CaseId) {
            GetComments(form.CaseId)
                .unwrap()
                .then((response) => {
                    const tempHistory = response as DTO_NTSPCaseNote[]
                    const convertedTimesHistory: DTO_NTSPCaseNote[] = tempHistory.map(
                        (item: DTO_NTSPCaseNote) => {
                            return {
                                ...item,
                                ts_CreationDateTime:
                                    convertEasternToLocal(item.ts_CreationDateTime?.toString()) ??
                                    '', //needs to return a string to convert time to local
                            }
                        }
                    )
                    if (convertedTimesHistory !== null) {
                        setHistory(convertedTimesHistory)
                    }
                })
                .catch((error) => {
                    console.error('Error:', error)
                })
        }
    }, [form, GetComments])

    useEffect(() => {
        setRemainingNotes(2048 - comment.trim().length)
        if (comment.trim() !== '') {
            setError(false)
        }
    }, [comment])

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        if (comment.trim() === '') {
            setError(true)
            return
        }
        if (form?.CaseId) {
            const newComment: Partial<DTO_NTSPCaseNote> = {
                CaseId: form.CaseId,
                Note: comment,
                ts_CreationDateTime: new Date(),
                tzCode: timezone,
                PostedByUserFullName: currentUserName,
                PostedByUserId: currentUserId,
            }
            try {
                const saved = await SaveComments(newComment).unwrap()
                const convertedTimeSaved = {
                    ...saved,
                    ts_CreationDateTime:
                        convertEasternToLocal(saved.ts_CreationDateTime?.toString()) ?? '',
                }
                if (saved) {
                    setHistory([...history, convertedTimeSaved])
                    setComment('')
                }
            } catch (error) {
                console.error('Error:', error)
            }
        }
    }

const debouncedHandleSave = usePromiseDebounce(async (...args: Parameters<typeof handleSave>) => {
        return await Promise.resolve(handleSave(...args));
    }); //FP-12575 debounce to prevent multiple rapid clicks

    return (
        <>
        <div className='sticky-Patient-header'>
            <PatientDetailsHeader
                form={form}
                NTSPElements={NTSPElements}
            />
            </div>
            <div className="ntsp-form-container">
                <div
                    style={{
                        padding: '24px',
                    }}
                >
                    <div className="row mb-2">
                        <div className="col-md-12">
                            <div className="row mb-4">
                                <div className="col-1 p-0">History</div>
                                <div className="col-10 p-0">
                                    <div
                                        style={{
                                            border: '1px solid #888',
                                            borderRadius: '2px',
                                            margin: '0 auto',
                                            maxWidth: '80vw',
                                            background: 'transparent',
                                            padding: '15px',
                                        }}
                                    >
                                        <div style={{ minHeight: '150px' }}>
                                            {history.map((item: DTO_NTSPCaseNote, idx) => (
                                                <div
                                                    key={item.Id ?? idx}
                                                    style={{
                                                        marginBottom: '18px',
                                                        textAlign:
                                                            item.PostedByUserId === currentUserId
                                                                ? 'right'
                                                                : 'left', // Adjust as needed
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            marginBottom: '4px',
                                                            fontSize: '12px',
                                                        }}
                                                    >
                                                        {new Date(item.ts_CreationDateTime)
                                                            .toLocaleString('en-US', {
                                                                hour: 'numeric',
                                                                minute: '2-digit',
                                                                hour12: false,
                                                                month: '2-digit',
                                                                day: '2-digit',
                                                                year: 'numeric',
                                                            })
                                                            .replace(',', '')}
                                                    </div>
                                                    <div
                                                        style={{
                                                            display: 'inline-block',
                                                            maxWidth: '60%',
                                                            textAlign: 'left',
                                                            marginLeft:
                                                                item.PostedByUserId ===
                                                                currentUserId
                                                                    ? 'auto'
                                                                    : '0',
                                                            marginRight:
                                                                item.PostedByUserId ===
                                                                currentUserId
                                                                    ? '0'
                                                                    : 'auto',
                                                            wordBreak: 'break-word',
                                                        }}
                                                    >
                                                        <strong>
                                                            {currentUserId === item.PostedByUserId
                                                                ? 'Me'
                                                                : item.PostedByUserFullName}
                                                        </strong>
                                                        : {item.Note}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-12">
                            <div className="row mb-4">
                                <div className="col-1 p-0">Comment</div>
                                <div className="col-9 p-0">
                                    <textarea
                                        id="comment"
                                        value={comment}
                                        onChange={(e) => setComment(e.target.value)}
                                        maxLength={2048}
                                        onResize={() => {}}
                                        rows={3}
                                        style={{
                                            border: '1px solid #888',
                                            borderRadius: '2px',
                                            padding: '12px',
                                            minHeight: '91px',
                                            width: '100%',
                                            paddingBottom: '1.5rem',
                                            boxSizing: 'border-box',
                                        }}
                                    />
                                    {remainigNotes !== 2048 && (
                                        <span
                                            style={{
                                                position: 'absolute',
                                                bottom: '0.2rem',
                                                right: '1.3rem',
                                                fontSize: '10px',
                                                color: '#ff0000', // optional: muted text color
                                                pointerEvents: 'none', // prevent clicking
                                            }}
                                            id="CommentRemainingLabel"
                                        >
                                            {remainigNotes} characters remaining
                                        </span>
                                    )}
                                    {error && (
                                        <div style={{ color: 'red', marginTop: '10px' }}>
                                            Comment cannot be empty.
                                        </div>
                                    )}
                                </div>
                                <div className="col-2 p-0" style={{ alignContent: 'end' }}>
                                    <button
                                        type="button"
                                        style={{
                                            padding: '5px 22px',
                                            cursor: 'pointer',
                                            marginLeft: '23px',
                                        }}
                                        onClick={handleSubmit}
                                        className="app-button"
                                    >
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.5rem',
                        minWidth: '250px',
                        justifyContent: 'flex-end',
                        flex: 1,
                        alignItems: 'end',
                    }}
                >
                    <div style={{ display: 'flex', gap: '1rem' }}>
                        <FoundationsButton
                            buttonClasses="app-button"
                            tabIndex={19}
                            onClick={wrapHandleClear}
                            id={'clear-button'}
                            toolTipText="Currently opened case entry form will be saved and closed."
                            tooltipClasses="info-icon"
                        >
                            Close
                        </FoundationsButton>
                    </div>
                    {submitted && formError !== '' && (
                        <div style={{ color: 'red', textAlign: 'right', marginTop: '0.5rem' }}>
                            {formError}
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}
export default Comments
